export const setState = (state) => {
  return {
    type: "SET_ASSIGNMENT_STATE",
    payload: state,
  };
};

export default { setState };
